export default (state = {}, action) => {

    switch (action.type) {

        case 'CONFIGURE_CHATROOM':
            return {
                chatroom: action.chatroom,
            }
        case 'CREATE_CHATROOM_ERROR':
        case 'CHATROOM_SET_USERNAME_ERROR':
           return {
                error: action.err
           }
           
        case 'CHATROOM_SET_USERNAME':
            const newState = Object.assign({},state,{
                auth: {...action.payload}
            })
            return newState;
        
        case 'CHATROOM_LOGOUT':
            return Object.assign({},state,{
                auth: null
            });
            
        default:
            return state
    }
}
